module.exports = __webpack_public_path__ + "statics/img/warrantyEndDate.2921facb.svg";